<template>
  <v-container>
    <Navigation />
    <v-col
      cols="12"
      sm="12"
      xs="4"
      class="ml-2"
      :class="{ 'col-md-12': isChrome, 'col-md-10': isFirefox }"
    >
      <div class="container mx-5">
        <TableWithSearch
          :headers="allHeaders"
          :items="getFilters"
          :openDialog="openDialog"
          :title="title"
          @headersUpdated="updateHeaders"
        />
      </div>

      <v-dialog v-model="showAdd" max-width="500px" persistent>
        <v-card>
          <v-card-title class="flex-center">
            {{
              isEdit
                ? $tc("workflow.edit") + " " + $tc("workflow.filter")
                : $tc("workflow.add") + " " + $tc("workflow.filter")
            }}
          </v-card-title>

          <v-card-actions class="flex-center px-6">
            <v-form ref="form" v-model="valid">
              <v-alert
                dense
                v-if="error"
                color="red"
                elevation="5"
                outlined
                text
                type="error"
                align="center"
                class="mr-1 ml-1"
              >
                {{ alertValidate }}</v-alert
              >
              <DateNotCheck />
              <v-autocomplete
                v-model="data.operId"
                outlined
                label="Operador"
                :rules="rules"
                item-value="operId"
                item-text="name"
                :items="getAllOperators"
                v-show="!isEdit"
                dense
              />
              <v-autocomplete
                v-model="data.operId"
                outlined
                label="Operador"
                :rules="rules"
                item-value="operId"
                item-text="name"
                :items="getOperatorsEdit"
                v-show="isEdit"
                disabled
              />
              <div class="grid__switch">
                <v-switch
                  v-for="item in itemSwitch"
                  :key="item.label"
                  color="accent"
                  v-model="item.value"
                  inset
                  :label="item.label"
                ></v-switch>
              </div>
            </v-form>
          </v-card-actions>
          <div class="d-flex justify-space-between pb-4 px-4">
            <v-btn class="bt-exit" @click="cancel"
              >{{ $tc("editRegistrations.cancel") }}
            </v-btn>
            <v-btn class="bt-acept" @click="validate">
              {{ $tc("editRegistrations.acept") }}</v-btn
            >
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showDelete" max-width="300px" persistent>
        <v-card>
          <v-card-title class="flex-center">
            {{ $tc("workflow.delete") + " " + $tc("workflow.filter") }}
          </v-card-title>
          <v-card-actions class="flex-center pink">
            <v-btn class="bt-exit mr-2 mb-2" @click="cancel"
              >{{ $tc("editRegistrations.cancel") }}
            </v-btn>
            <v-btn class="bt-acept mb-2" @click="deleteFilter">
              {{ $tc("editRegistrations.acept") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isLoading"
        class="dialog__loader"
        :overlay-opacity="0.3"
      >
        <Loader :loading="isLoading" />
      </v-dialog>
    </v-col>

    <Alerts :alert="errorAlert" :color="colorError" :textAlert="textAlertOk" />
    <Alerts :alert="ok" :color="colorOk" :textAlert="textAlertOk" />
  </v-container>
</template>

<script>
import Navigation from "../commons/Navigation.vue";
import TableWithSearch from "../../Complement/TableWithSearch.vue";
import filters from "../../../store/workflow/filters";
import commons from "../../../store/workflow/commons";
import attributes from "../../../store/workflow/attributes";
import Loader from "../../Complement/Loader.vue";
import Alerts from "../../GestionEmpleados/commons/Alerts.vue";
import moment from "moment";
import DateNotCheck from "../commons/DateNotCheck.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: { Navigation, TableWithSearch, DateNotCheck, Loader, Alerts },
  data() {
    return {
      title: "Filtros",
      titleTable: "WF_Filtros",
      type: "Filtros",
      search: "",
      itemSwitch: [
        { label: "Mios", value: true, name: "mios" },
        { label: "Pendientes", value: true, name: "pending" },
        { label: "Aprobadas", value: true, name: "approved" },
        { label: "Rechazadas", value: true, name: "rejected" },
        { label: "Licencias", value: true, name: "licenses" },
        { label: "Cambio de horario", value: true, name: "cSchedule" },
        { label: "HsExtra", value: true, name: "hsExtra" },
        { label: " Lic. sobre feriado", value: true, name: "licF" },
        { label: "Delegación", value: true, name: "dele" },
      ],
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      error: false,
      alertValidate: "",
      valid: true,
      isLoading: false,
      colorError: "#FF8D58",
      colorOk: "#82A1D0",
      textAlertOk: "",
      errorAlert: false,
      data: {
        from: null,
        to: null,
        operId: null,
        mios: null,
        pending: null,
        approved: null,
        rejected: null,
        licenses: null,
        cSchedule: null,
        hsExtra: null,
        licF: null,
        dele: null,
      },
      ok: false,
      showDelete: false,
      deleteItems: null,
      headers: [
        {
          text: "Operador",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Desde",
          value: "from",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Hasta",
          value: "to",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Mios",
          value: "mios",
          class: "primary secondary--text",
          sortable: false,
          visible: true,
        },
        {
          text: "Pendientes",
          value: "pending",
          class: "primary secondary--text",
          sortable: false,
          visible: true,
        },
        {
          text: "Aprobadas",
          value: "approved",
          class: "primary secondary--text",
          sortable: false,
          visible: true,
        },
        {
          text: "Rechazadas",
          value: "rejected",
          class: "primary secondary--text",
          sortable: false,
          visible: true,
        },

        {
          text: "Licencias",
          value: "licenses",
          class: "primary secondary--text",
          sortable: false,
          visible: true,
        },
        {
          text: "cHorario",
          value: "cSchedule",
          class: "primary secondary--text",
          sortable: false,
          visible: true,
        },
        {
          text: "hsExtra",
          value: "hsExtra",
          class: "primary secondary--text",
          sortable: false,
          visible: true,
        },
        {
          text: "LicF",
          value: "licF",
          class: "primary secondary--text",
          sortable: false,
          visible: true,
        },
        {
          text: "Dele",
          value: "dele",
          class: "primary secondary--text",
          sortable: false,
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "150px",
        },
      ],
    };
  },

  mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    this.isLoading = true;
    filters.dispatch("getfilters").then(() => {
      this.isLoading = false;
    });
  },

  computed: {
    allHeaders() {
      return Array.isArray(configTable.state?.colums)
        ? configTable.state.colums
        : [];
    },
    getFilters() {
      return filters.state.filters;
    },
    isChrome() {
      return (
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor)
      );
    },
    isFirefox() {
      return /Firefox/.test(navigator.userAgent);
    },
    isEdit: {
      get() {
        return commons.state.isEdit;
      },
      set(newValue) {
        return newValue;
      },
    },
    showAdd: {
      get() {
        return commons.state.showAdd;
      },
      set(newValue) {
        return newValue;
      },
    },
    getOperatorsEdit() {
      return this.operatorsEdit();
    },
    getAllOperators() {
      const array3 = attributes.state.attributes.filter(
        (obj) =>
          !filters.state.filters.some(({ operId }) => obj.operId === operId),
      );
      return array3;
    },
  },
  methods: {
    updateHeaders(headers) {
      const updatedColums = headers;

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    openDialog(type, item) {
      switch (type) {
        case "add":
          this.addExecution();
          break;
        case "edit":
          this.editExecution(item);
          break;
        case "delete":
          this.deleteExecution(item);
          break;

        default:
          break;
      }
    },
    addExecution() {
      attributes.dispatch("getAttributes");
      commons.commit("setShowAdd", true);
      commons.commit("setIsEdit", false);
    },
    deleteExecution(item) {
      this.showDelete = true;
      this.deleteItems = item.operId;
    },
    editExecution(item) {
      attributes.dispatch("getAttributes");
      commons.commit("setShowAdd", true);
      this.showAdd = true;
      commons.commit("setIsEdit", true);
      this.isEdit = true;
      this.itemSwitch = [
        {
          label: "Mios",
          value: item.mios !== "✔️" ? false : true,
          name: "mios",
        },
        {
          label: "Pendientes",
          value: item.pending !== "✔️" ? false : true,
          name: "pending",
        },
        {
          label: "Aprobadas",
          value: item.approved !== "✔️" ? false : true,
          name: "approved",
        },
        {
          label: "Rechazadas",
          value: item.rejected !== "✔️" ? false : true,
          name: "rejected",
        },
        {
          label: "Licencias",
          value: item.licenses !== "✔️" ? false : true,
          name: "licenses",
        },
        {
          label: "CHorario",
          value: item.cSchedule !== "✔️" ? false : true,
          name: "cSchedule",
        },
        {
          label: "HsExtra",
          value: item.hsExtra !== "✔️" ? false : true,
          name: "hsExtra",
        },
        {
          label: "LicF",
          value: item.licF !== "✔️" ? false : true,
          name: "licF",
        },
        {
          label: "Dele",
          value: item.dele !== "✔️" ? false : true,
          name: "dele",
        },
      ];

      this.data = {
        operId: item.operId,
        name: item.name,
        from: item.from.slice(0, 10).split(/\D/).reverse().join("-"),
        to:
          item.to !== " "
            ? item.to.slice(0, 10).split(/\D/).reverse().join("-")
            : null,
        columnas: item.columnas,
      };

      commons.commit("setDateTo", this.data.to);
      commons.commit("setDateFrom", this.data.from);
    },
    validate() {
      let valid = this.$refs.form.validate();

      if (valid) {
        if (this.isEdit) {
          this.edit();
        } else {
          this.add();
        }
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    cancel() {
      if (this.showAdd) {
        commons.commit("setShowAdd", false);
        this.showAdd = false;
        this.isEdit = false;
        this.$refs.form.resetValidation();
        (this.data = {
          from: null,
          to: null,
          operId: null,
          haNoEx: null,
          mios: null,
          pending: null,
          approved: null,
          rejected: null,
          licenses: null,
          cSchedule: null,
          hsExtra: null,
          licF: null,
          dele: null,
        }),
          (this.itemSwitch = [
            { label: "Mios", value: true, name: "mios" },
            { label: "Pendientes", value: true, name: "pending" },
            { label: "Aprobadas", value: true, name: "approved" },
            { label: "Rechazadas", value: true, name: "rejected" },
            { label: "Licencias", value: true, name: "licenses" },
            { label: "Cambio de horario", value: true, name: "cSchedule" },
            { label: "HsExtra", value: true, name: "hsExtra" },
            { label: " Lic. sobre feriado", value: true, name: "licF" },
            { label: "Delegación", value: true, name: "dele" },
          ]),
          (this.ok = false);
        this.errorAlert = false;
        const day = moment().format("YYYY-MM-DD");
        commons.commit("setDateTo", null);
        commons.commit("setDateFrom", day);
      } else {
        this.showDelete = false;
      }
    },
    edit() {
      this.isLoading = true;
      let payload = {
        operId: this.data.operId,
        from: commons.state.dateFrom,
        to: commons.state.dateTo,
        haNoEx: this.data.haNoEx,
        name: this.searchOper(this.data.operId),
        mios: this.itemSwitch[0].value,
        pending: this.itemSwitch[1].value,
        approved: this.itemSwitch[2].value,
        rejected: this.itemSwitch[3].value,
        licenses: this.itemSwitch[4].value,
        cSchedule: this.itemSwitch[5].value,
        hsExtra: this.itemSwitch[6].value,
        licF: this.itemSwitch[7].value,
        dele: this.itemSwitch[8].value,
        columnas: this.data.columnas,
      };

      filters.commit("setEdit", payload);
      filters
        .dispatch("edit")
        .then(() => {
          this.ok = true;
          this.isLoading = false;
          this.textAlertOk = "Se editó el filtro";
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
          this.errorAlert = true;
          this.textAlertOk = e.response.data.error.message;
        });
      this.cancel();
    },
    add() {
      let payload = {
        from: commons.state.dateFrom + "T00:00:00.000Z",
        to:
          commons.state.dateTo !== null
            ? commons.state.dateTo + "T00:00:00.000Z"
            : null,
        operId: this.data.operId,
        haNoEx: null,
        mios: this.itemSwitch[0].value,
        pending: this.itemSwitch[1].value,
        approved: this.itemSwitch[2].value,
        rejected: this.itemSwitch[3].value,
        licenses: this.itemSwitch[4].value,
        cSchedule: this.itemSwitch[5].value,
        hsExtra: this.itemSwitch[6].value,
        licF: this.itemSwitch[7].value,
        dele: this.itemSwitch[8].value,
        name: this.searchOper(this.data.operId),
      };
      filters.commit("setNew", payload);
      filters
        .dispatch("new")
        .then(() => {
          this.ok = true;
          this.isLoading = false;
          this.textAlertOk = "Se agrego el filtro";
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
          this.errorAlert = true;
          this.textAlertOk = e.response.data.error.message;
        });

      this.cancel();
    },
    searchOper(item) {
      let name = attributes.state.attributes.filter(
        (element) => {
          return element.operId === item;
        },
        [0],
      );
      return name[0].name;
    },
    deleteFilter() {
      this.isLoading = true;
      filters.commit("setDeleteItem", this.deleteItems);
      filters
        .dispatch("delete")
        .then(() => {
          this.ok = true;
          this.isLoading = false;
          this.textAlertOk = "Se elimino el filtro";
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
          this.errorAlert = true;
          this.textAlertOk = e.response.data.error.message;
        });

      this.cancel();
    },
    operatorsEdit() {
      let allOpers = attributes.state.attributes.filter((oper) => {
        if (oper.operId == this.data.operId) {
          return true;
        }

        return true;
      });
      return allOpers;
    },
  },
};
</script>

<style scoped>
.grid__switch {
  display: grid !important;
  grid-template-columns: 153px 153px 153px;
  justify-self: center !important;
  padding-left: 13px !important;
}

.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.flex-center {
  display: flex;
  justify-content: center;
}
.container {
  max-width: 100%;
}
</style>
